import Swal from "sweetalert2";
import sexos from "$lib/stores/sexos";
export function isEmpty(str) {
    return (!str || str.length === 0);
}
export function capitalize(s) {
    return (s && String(s[0]).toUpperCase() + String(s).slice(1)) || ""
}
export function addDays(date, days) {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
}
export function randomString(len, an) {
    an = an && an.toLowerCase();
    var str = "",
        i = 0,
        min = an == "a" ? 10 : 0,
        max = an == "n" ? 10 : 62;
    for (; i++ < len;) {
        var r = Math.random() * (max - min) + min << 0;
        str += String.fromCharCode(r += r > 9 ? r < 36 ? 55 : 61 : 48);
    }
    return str;
}
export function getWholeWordButLastLetter(word) {
    let newword = word.slice(0, word.length - 2)
    return newword
}
export function getSexoNombre(s) {
    let sex = sexos.filter(se => se.id == s)[0]
    if (sex) {
        return sex.nombre
    }
    else {
        return ""
    }

}
export function shorterWord(cadena, maxLongitud = 15) {
    if (cadena == null || cadena == undefined) {
        return ""
    }

    let sufijo = "..."
    return cadena.length > maxLongitud
        ? cadena.substring(0, maxLongitud) + sufijo
        : cadena;
}
export function diasEntreFechas(startDate, endDate) {
    const date1 = new Date(startDate);
    const date2 = new Date(endDate);

    const time1 = date1.getTime();
    const time2 = date2.getTime();

    const differenceInMilliseconds = Math.abs(time2 - time1); // Use Math.abs for absolute difference

    const millisecondsPerDay = 1000 * 60 * 60 * 24;
    const daysDifference = Math.round(differenceInMilliseconds / millisecondsPerDay);

    return daysDifference;
}
// Instancia de SweetAlert2 con la identidad visual de Fertilapp.
// `buttonsStyling: false` desactiva los estilos inline de la librería para
// que el aspecto venga 100% de las clases `.fertil-swal-*` definidas en
// `src/app.css` (verde de marca #115642, rojo #A94442, Noto Sans, bordes
// redondeados, soporte dark mode). Todas las llamadas a InfoSwal/AskSwal/
// ErrorSwal/AskDangerSwal pasan por acá, así que estilizar un solo lugar
// alcanza para unificar todos los popups de la app.
export const FertilSwal = Swal.mixin({
    buttonsStyling: false,
    customClass: {
        popup: "fertil-swal-popup",
        title: "fertil-swal-title",
        htmlContainer: "fertil-swal-text",
        actions: "fertil-swal-actions",
        confirmButton: "fertil-swal-confirm",
        cancelButton: "fertil-swal-cancel",
        denyButton: "fertil-swal-deny",
    },
});

export function InfoSwal(title, text, icon) {
    return FertilSwal.fire({ title, text, icon });
}
export function AskSwal(
    title, text, icon, showCancelButton,
    confirmButtonText, cancelButtonText
) {
    return FertilSwal.fire({
        title,
        text,
        icon,
        showCancelButton,
        confirmButtonText,
        cancelButtonText,
        reverseButtons: true,
    })
}
// Confirmación de una acción destructiva (eliminar / dar de baja): el botón
// de confirmar usa el rojo de marca en lugar del verde.
export function AskDangerSwal(
    title, text, showCancelButton = true,
    confirmButtonText = "Eliminar", cancelButtonText = "Cancelar"
) {
    return FertilSwal.fire({
        title,
        text,
        icon: "warning",
        showCancelButton,
        confirmButtonText,
        cancelButtonText,
        reverseButtons: true,
        customClass: {
            popup: "fertil-swal-popup",
            title: "fertil-swal-title",
            htmlContainer: "fertil-swal-text",
            actions: "fertil-swal-actions",
            confirmButton: "fertil-swal-deny",
            cancelButton: "fertil-swal-cancel",
        },
    })
}
// Popup de error pensado para bloques catch. Nunca muestra el texto crudo del
// backend (evita filtrar detalles técnicos al usuario) y silencia el caso de
// sesión expirada, que ya maneja el evento `session-expired`. Pasale un
// `title` y `text` amigables y, opcionalmente, el `error` capturado.
export function ErrorSwal(title, text, error) {
    if (error?.message === "SESIÓN_EXPIRADA") return;
    return FertilSwal.fire({ title, text, icon: "error" });
}

// ---------------------------------------------------------------------------
// Helpers semánticos de notificación.
//
// Unifican TODOS los popups de resultado de la app en cuatro categorías. El
// título es FIJO por categoría (constante, sin tildes inconsistentes ni
// sinónimos) y el `msg` que pasás es el que lleva el detalle representativo:
// siempre describe la acción + la entidad + el resultado concreto.
//
//   ok("El tacto se guardó correctamente")
//   fail("No se pudieron registrar algunos servicios. Intenta de nuevo")
//   validar("Selecciona al menos un animal para registrar el pesaje")
//   noPermission("No tienes permisos para crear animales")
//
// Tono: tuteo neutro ("revisa", "selecciona", "verifica"). No reintroduzcas
// títulos ad-hoc tipo "Éxito tactos" / "Error pesaje": usá estos helpers.
export function ok(msg) {
    return InfoSwal("Listo", msg, "success");
}
export function fail(msg) {
    return InfoSwal("No se pudo completar", msg, "error");
}
export function validar(msg) {
    return InfoSwal("Revisa los datos", msg, "warning");
}
export function noPermission(msg) {
    return InfoSwal("Sin permisos", msg, "warning");
}
// Tope del plan alcanzado. NO va con fail(): no es un error del usuario ni algo
// que se arregle reintentando, y el rojo de "No se pudo completar" leia como si
// la app se hubiera roto justo despues de crear el primer establecimiento. Es
// informativo: dice el estado, deja al usuario donde estaba y no vende nada
// (sin precio ni link, decision #5 de docs/suscripciones-flujo-propuesto.md
// §3.3 — la app no puede empujar a comprar, ni en iOS ni en el resto).
export function avisoPlan(msg) {
    return InfoSwal("Tu plan", msg, "info");
}
export function formatFecha(iso) {
    if (!iso) return "";
    const d = new Date(String(iso).slice(0, 10) + " 03:00:00");
    if (isNaN(d.getTime())) return "";
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
}
// A diferencia de formatFecha, acá el valor SÍ trae hora real (ej. movimientos):
// sin el pin a 03:00:00, se muestra la hora tal cual vino.
// Movimientos de antes de que existiera este campo quedaron en 00:00 al
// ensancharse la columna de DATE a DATETIME: no es que pasaron a medianoche,
// es que no se registró hora. Como no hay forma de distinguirlo de un
// movimiento real a las 00:00 (caso extremadamente raro acá), se omite la
// hora cuando es exactamente 00:00 en vez de mostrar un dato inventado.
export function formatFechaHora(iso) {
    if (!iso) return "";
    const d = new Date(iso);
    if (isNaN(d.getTime())) return "";
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();
    const fecha = `${day}/${month}/${year}`;
    if (d.getHours() === 0 && d.getMinutes() === 0) return fecha;
    const hours = String(d.getHours()).padStart(2, '0');
    const minutes = String(d.getMinutes()).padStart(2, '0');
    return `${fecha} ${hours}:${minutes}`;
}
// "YYYY-MM-DDTHH:mm" del momento actual en hora LOCAL (no toISOString, que es UTC).
export function nowLocalDateTimeISO() {
    const d = new Date();
    const pad = (n) => String(n).padStart(2, '0');
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}
